import Ternary from '@/components/Tenary';
import { QUERY_KEYS } from '../../../../../type';
import { useAnnotatedTaskId } from '@/pages/CustomCenter/ExtractConfig/stores';
import { useTab } from '@/pages/CustomCenter/ExtractConfig/stores/useTab';
import { Button } from '@ai-indeed/idp-ui';
import { useQuery, useQueryClient, useSearchParams } from '@umijs/max';
import { message, Progress, Spin } from 'antd';
import { FC, useMemo } from 'react';
import * as API from '../service';
import useAnnotationData from '../hooks/use-annotation-data';
import { useStore } from '../../../store';

const AnnotationCard: FC<{
  template_code: string;
  node_uid: string;
}> = (props) => {
  const [_, setTabKey] = useTab();
  const emitter = useStore((s) => s.eventEmitter);
  // shared state
  const setActiveId = useAnnotatedTaskId()[1];
  // search params
  // const searchParams = useSearchParams()[0];
  // const templateCode = searchParams.get('template-code');
  // query client
  const queryClient = useQueryClient();

  const { isLoading: loading, data } = useAnnotationData({
    template_code: props.template_code,
    node_uid: props.node_uid,
  });

  const NothingJSX = useMemo(() => {
    return (
      <div className="h-[100px] flex flex-col items-center justify-center gap-1 ">
        <p className="text-center">暂无数据</p>
        <p
          className="text-primary inline-block cursor-pointer"
          onClick={async () => {
            const id = await API.createNlpNodeAnnotationTask({
              template_code: props.template_code,
              node_uid: props.node_uid,
            });
            message.success('创建成功');
            await queryClient.refetchQueries({
              queryKey: [QUERY_KEYS.ANNOTATION_CONFIG],
            });
            setActiveId(id);
            setTabKey('ANNOTATION_CONFIG');
          }}
        >
          去配置
        </p>
      </div>
    );
  }, [props.template_code, props.node_uid]);

  const handleAnnotation = async (annotated_task_id?: number) => {
    emitter?.emit({ type: 'SWITCH_TAB' });

    if (!annotated_task_id) return;
    setActiveId(+annotated_task_id);
    setTabKey('ANNOTATION_CONFIG');
  };

  return (
    <div className="rounded bg-[var(--bg-main-color)] p-4">
      <Spin spinning={loading}>
        <Ternary condition={Boolean(data)} falseElement={NothingJSX}>
          <div className="space-y-3">
            <div className="text-xl text-blue-400 font-semibold">
              {data?.annotated_progress}%
            </div>
            <Progress percent={data?.annotated_progress} />
            <div className="flex items-center justify-between">
              <div className="text-sm text-blue-400">
                未标注：{data?.un_annotated_count}
              </div>
              <div className="text-sm text-gray-500">
                已标注：{data?.annotated_count}
              </div>
            </div>
            <Button
              onClick={() => {
                handleAnnotation(data?.annotated_task_id);
              }}
              type="outline1"
              className="w-full"
            >
              去标注
            </Button>
          </div>
        </Ternary>
      </Spin>
    </div>
  );
};

export default AnnotationCard;
